import NotificationActions from 'client/js/main/actions/NotificationActions';
import dash_api from 'client/js/main/support/dash_api';
import type { SetupEmailIngestorRequestActionPayload } from 'client/js/redux/domains/EmailIngestor/EmailIngestor.types';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { Action } from 'redux';
import type { EmailIngestor } from 'shared/types/roi-hub/fileIngestion.types';

const SetupEmailIngestor = new ReduxAsyncAction<
  'EMAIL_INGESTOR_SETUP_INGESTOR',
  SetupEmailIngestorRequestActionPayload,
  EmailIngestor
>('EMAIL_INGESTOR_SETUP_INGESTOR');

SetupEmailIngestor.registerRequest(async (payload) => {
  try {
    const { data } = await dash_api.post<EmailIngestor>('/v1/roi/email-ingestor', payload);

    NotificationActions.showNotification('Setup complete. Provide your ad partner with email alias', 'success');

    return data;
  } catch (error) {
    NotificationActions.showNotification('Error occurred when setting up email importer', 'error');
    throw error;
  }
});

export const SETUP_EMAIL_INGESTOR = SetupEmailIngestor.actionNamespaceConstants;

export const setupEmailIngestor = SetupEmailIngestor.request;

export type SetupEmailIngestorResponseAction = Action<typeof SETUP_EMAIL_INGESTOR.response> & { data: EmailIngestor };
